import { useMediaQuery } from '@abyss/web/hooks/useMediaQuery';
import { Flex } from '@abyss/web/ui/Flex';
import { Link } from '@abyss/web/ui/Link';
import { Text } from '@abyss/web/ui/Text';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { getProviderTitle } from '../../../../common/Utils';
import { useCurrentMemberIsPreEffective } from '../../../../hooks/useCurrentMemberIsPreEffective';
import { useLagoon } from '../../../../hooks/useLagoon';
import { TypeaheadCoverageTypes } from '../../../Constants';
import { mobileOnly } from '../../../ConstantsStyles';
import { PSXIcon } from '../../../PSXIcon';
import {
  CoverageIcon,
  CoverageType,
  Divider,
} from './KeywordSearchDropdown.styled';

export const VirtualCareProvidersList = ({
  providers,
  setSelectedProviderName,
  setIsModalOpen,
  showDivider = true,
}) => {
  const { t } = useTranslation();
  const uiMessaging = useLagoon('ui-messaging')();
  const mobileScreen = useMediaQuery(mobileOnly);
  const isPreEffective = useCurrentMemberIsPreEffective();
  return (
    <React.Fragment>
      {showDivider && <Divider />}
      <Text
        color="$gray8"
        data-testid="virtual-care-section-heading"
        fontWeight={700}
        size="14px"
      >
        {t('Virtual care')}
      </Text>
      {providers.map((prov, idx) => (
        <Flex
          align="start"
          css={{
            gap: '16px',
            '@media (max-width: 600px)': {
              gap: '8px',
            },
          }}
          direction="row"
          key={prov.providerName + idx}
        >
          {prov?.logo && (
            <div
              style={{
                width: mobileScreen ? '60px' : '96px',
                alignItems: mobileScreen ? '' : 'center',
                justifyContent: mobileScreen ? '' : 'center !important',
                display: mobileScreen ? '' : 'flex',
                height: mobileScreen ? 'auto' : '40px',
              }}
            >
              <img
                alt={`${prov.providerName} logo`}
                src={prov.logo}
                style={{
                  height: '25px',
                  objectFit: 'contain',
                  display: 'block',
                  margin: '0 auto',
                }}
              />
            </div>
          )}
          <Flex
            alignItems="center"
            css={{
              gap: '8px',
              flexDirection: 'row',
              '@media (max-width: 600px)': {
                alignItems: 'center',
                width: '250px',
              },
            }}
            justify="flex-start"
          >
            <Link
              css={{
                'abyss-link-root': {
                  fontSize: '16px',
                  lineHeight: '20px',
                  fontWeight: 700,
                  textAlign: 'center',
                },
              }}
              data-auto-testid={`virtual-care-${prov?.providerName}-link-text`}
              data-testid={`virtual-care-${prov?.providerName}-link-text`}
              isDisabled={isPreEffective}
              onClick={(e) => {
                e.preventDefault();
                if (isPreEffective) return;
                setSelectedProviderName(prov?.providerName);
                setIsModalOpen(true);
              }}
            >
              {prov?.providerName}
            </Link>
            <Text
              color="$gray7"
              data-testid="heading-typeahead-suggested-searches"
              fontWeight={400}
              size="16px"
            >
              {prov.serviceType
                ?.split(',')
                .map((type) => getProviderTitle(type, uiMessaging, prov))
                .join(', ')}
            </Text>
            <Text css={CoverageType}>
              <div
                style={{
                  backgroundColor: '#F2F8E6',
                }}
              >
                <PSXIcon icon="Stethoscope" size={16} style={CoverageIcon} />
                {t(TypeaheadCoverageTypes.MEDICAL)}
              </div>
            </Text>
          </Flex>
        </Flex>
      ))}
    </React.Fragment>
  );
};
